import { usePermissionData } from "AppContext"
import Breadcrumb from "components/Common/Breadcrumb"
import Loader from "components/Loader/Loader"
import moment from "moment"
import PermittedComponent from "PermittedComponent"
import React, { useState, useMemo, useEffect } from "react"
import { FaPlus } from "react-icons/fa"
import { MdCancel, MdCheck, MdDelete, MdEdit } from "react-icons/md"
import {
  Card,
  CardBody,
  Button,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Row,
  Col,
  Badge,
  Table,
} from "reactstrap"
import Swal from "sweetalert2"
import {
  fetchData,
  FetchPostData,
  FetchPutData,
} from "utils/Common_api_functions"

const allowOnlyNumbers = e => {
  e.target.value = e.target.value.replace(/[^0-9]/g, "")
}

const PAGE_SIZE_OPTIONS = [10, 20, 50]
const emptyForm = { userId: "", date: "", amount: "", reason: "" }
const fmt = n => `₹${Number(n).toLocaleString("en-IN")}`

const MONTHS = [
  { label: "All Months", value: "" },
  { label: "January", value: "1" },
  { label: "February", value: "2" },
  { label: "March", value: "3" },
  { label: "April", value: "4" },
  { label: "May", value: "5" },
  { label: "June", value: "6" },
  { label: "July", value: "7" },
  { label: "August", value: "8" },
  { label: "September", value: "9" },
  { label: "October", value: "10" },
  { label: "November", value: "11" },
  { label: "December", value: "12" },
]

const currentYear = new Date().getFullYear()
const YEARS = [
  { label: "All Years", value: "" },
  ...Array.from({ length: currentYear - 2020 + 1 }, (_, i) => ({
    label: String(2020 + i),
    value: String(2020 + i),
  })).reverse(),
]

const Advance = () => {
  document.title = "Employee Advance | Vintage Infra Equipment Sol PVT LTD"
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [search, setSearch] = useState("")
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [selectedMonth, setSelectedMonth] = useState(
    String(moment().month() + 1)
  )
  const [selectedYear, setSelectedYear] = useState(String(moment().year()))
  const [EMPLOYEES, setEMPLOYEES] = useState([])

  // modal state
  const [modal, setModal] = useState(false)
  const [editId, setEditId] = useState(null)
  const [form, setForm] = useState(emptyForm)
  const [formErr, setFormErr] = useState({})

  useEffect(() => {
    getEmployees()
    getAdvance()
  }, [])

  async function getEmployees() {
    const APIdata = await fetchData(setLoading, "users")
    if (APIdata?.success) setEMPLOYEES(APIdata?.data)
  }

  async function getAdvance() {
    const APIdata = await fetchData(setLoading, "advance")
    if (APIdata?.success) setData(APIdata?.data?.reverse())
  }

  // ── filtering ─────────────────────────────────────────────────────────────
  const filtered = useMemo(() => {
    let result = data

    console.log(data)
    console.log(selectedMonth)
    console.log(result.map(r => moment(r.date).format("MM")))

    if (selectedYear)
      result = result.filter(
        r => moment(r.date).format("YYYY") === String(selectedYear)
      )

    if (selectedMonth)
      result = result.filter(
        r => moment(r.date).format("M") === String(selectedMonth)
      )

    if (search.trim()) {
      const q = search.toLowerCase()
      result = result.filter(
        r =>
          r.user?.name.toLowerCase().includes(q) ||
          r.date.includes(q) ||
          String(r.amount).includes(q) ||
          r.reason.toLowerCase().includes(q)
      )
    }

    return result
  }, [data, search, selectedMonth, selectedYear])

  const activeFilters = [selectedYear, selectedMonth, search.trim()].filter(
    Boolean
  ).length

  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize))
  const safePage = Math.min(page, totalPages)
  const paged = filtered.slice((safePage - 1) * pageSize, safePage * pageSize)

  // ── approve / reject ──────────────────────────────────────────────────────
  const toggleApprove = (id, status) => {
    Swal.fire({
      title: `Are you sure you want to ${
        status ? "Approve" : "Reject"
      } this Advance?`,
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    }).then(async result => {
      if (result.isConfirmed) {
        const APIdata = await FetchPutData(setLoading, "advance", id, {
          status,
        })
        if (APIdata?.data?.success) {
          Swal.fire({
            title: `Advance ${status ? "Approved" : "Rejected"} Successfully.`,
            text: APIdata?.data?.message,
            icon: "success",
          })
          getAdvance()
        } else {
          Swal.fire({
            title: "Error Updating Status of Advance.",
            text: APIdata?.response?.data?.message,
            icon: "error",
          })
        }
      }
    })
  }

  const openAdd = () => {
    setEditId(null)
    setForm(emptyForm)
    setFormErr({})
    setModal(true)
  }

  const openEdit = row => {
    setEditId(row.id)
    setForm({
      userId: row.userId,
      date: row.date,
      amount: row.amount,
      reason: row.reason,
    })
    setFormErr({})
    setModal(true)
  }

  const validate = () => {
    const err = {}
    if (!form.userId) err.userId = "Select an employee"
    if (!form.date) err.date = "Select a date"
    if (!form.amount || isNaN(form.amount) || Number(form.amount) <= 0)
      err.amount = "Enter a valid amount"
    if (!form.reason.trim()) err.reason = "Enter a reason"
    setFormErr(err)
    return Object.keys(err).length === 0
  }

  const handleSave = async () => {
    if (!validate()) return
    if (editId) {
      const APIdata = await FetchPutData(setLoading, "advance", editId, form)
      if (APIdata?.data?.success) {
        Swal.fire({
          title: "Advance Updated Successfully.",
          text: APIdata?.data?.message,
          icon: "success",
        })
        getAdvance()
        setModal(false)
      } else {
        Swal.fire({
          title: "Error Updating Advance.",
          text: APIdata?.response?.data?.message,
          icon: "error",
        })
      }
    } else {
      const APIdata = await FetchPostData(setLoading, "advance", form)
      if (APIdata?.data?.success) {
        Swal.fire({
          title: "Advance Added Successfully.",
          text: APIdata?.data?.message,
          icon: "success",
        })
        getAdvance()
        setModal(false)
      } else {
        Swal.fire({
          title: "Error adding Advance.",
          text: APIdata?.response?.data?.message,
          icon: "error",
        })
      }
    }
  }

  const handleDelete = id => {
    Swal.fire({
      title: "Are you sure you want to delete Advance?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async result => {
      if (result.isConfirmed) {
        const APIdata = await FetchDeleteData(setLoading, "advance", id)
        if (APIdata?.data?.success) {
          Swal.fire({
            title: "Advance Deleted Successfully.",
            text: APIdata?.data?.message,
            icon: "success",
          })
          getAdvance()
        } else {
          Swal.fire({
            title: "Error Deleting Advance.",
            text: APIdata?.response?.data?.message,
            icon: "error",
          })
        }
      }
    })
  }

  const { checkAccess } = usePermissionData()

  return (
    <PermittedComponent isAccess={checkAccess(1, "view")}>
      <div className="page-content">
        {loading && <Loader />}
        <Breadcrumb title="Payroll" breadcrumbItem="Employee Advance" />

        <Card>
          <CardBody>
            {/* ── Toolbar ── */}
            <Row className="mb-3 align-items-center g-2">
              {/* Left side */}
              <Col md={9} className="d-flex align-items-center gap-2 flex-wrap">
                {/* Page size */}
                <Input
                  type="select"
                  className="rounded-4"
                  value={pageSize}
                  onChange={e => {
                    setPageSize(Number(e.target.value))
                    setPage(1)
                  }}
                  style={{ width: 80 }}
                >
                  {PAGE_SIZE_OPTIONS.map(n => (
                    <option key={n}>{n}</option>
                  ))}
                </Input>

                {/* Search */}
                <div style={{ position: "relative" }}>
                  <i
                    className="bx bx-search"
                    style={{
                      position: "absolute",
                      left: 10,
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#aaa",
                      fontSize: 18,
                    }}
                  />
                  <Input
                    placeholder="Search Advance"
                    className="rounded-4"
                    value={search}
                    onChange={e => {
                      setSearch(e.target.value)
                      setPage(1)
                    }}
                    style={{ paddingLeft: 34, width: 200 }}
                  />
                </div>

                {/* Month Dropdown */}
                <div style={{ position: "relative" }}>
                  <Input
                    type="select"
                    className="rounded-4"
                    value={selectedMonth}
                    onChange={e => {
                      setSelectedMonth(e.target.value)
                      setPage(1)
                    }}
                    style={{
                      width: 145,
                      borderColor: selectedMonth ? "#556ee6" : undefined,
                      color: selectedMonth ? "#556ee6" : undefined,
                      fontWeight: selectedMonth ? 600 : undefined,
                    }}
                  >
                    {MONTHS.map(m => (
                      <option key={m.value} value={m.value}>
                        {m.label}
                      </option>
                    ))}
                  </Input>
                </div>

                {/* Year Dropdown */}
                <div style={{ position: "relative" }}>
                  <Input
                    type="select"
                    className="rounded-4"
                    value={selectedYear}
                    onChange={e => {
                      setSelectedYear(e.target.value)
                      setPage(1)
                    }}
                    style={{
                      width: 130,
                      borderColor: selectedYear ? "#556ee6" : undefined,
                      color: selectedYear ? "#556ee6" : undefined,
                      fontWeight: selectedYear ? 600 : undefined,
                    }}
                  >
                    {YEARS.map(y => (
                      <option key={y.value} value={y.value}>
                        {y.label}
                      </option>
                    ))}
                  </Input>
                </div>
              </Col>

              {/* Right side — Add button */}
              <Col md={3} className="text-end">
                {checkAccess(13, "add") && (
                  <Button onClick={openAdd} className="btn-blue rounded-4 px-3">
                    <FaPlus /> Add Advance
                  </Button>
                )}
              </Col>
            </Row>

            {/* ── Table ── */}
            <div className="table-responsive">
              <Table bordered hover className="align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Employee Name</th>
                    <th>Advance Date</th>
                    <th>Amount</th>
                    <th>Reason</th>
                    <th>Status</th>
                    <th>Approval</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {paged.length === 0 ? (
                    <tr>
                      <td colSpan={8} className="text-center text-muted py-4">
                        {activeFilters > 0
                          ? "No records found for the selected filters"
                          : "No records found"}
                      </td>
                    </tr>
                  ) : (
                    paged.map((row, idx) => (
                      <tr key={row.id}>
                        <td>{(safePage - 1) * pageSize + idx + 1}</td>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <div
                              style={{
                                width: 32,
                                height: 32,
                                borderRadius: "50%",
                                background: "#556ee620",
                                color: "#556ee6",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: 700,
                                fontSize: 13,
                                flexShrink: 0,
                              }}
                            >
                              {row.user?.name.charAt(0)}
                            </div>
                            {row.user?.name}
                          </div>
                        </td>
                        <td>{moment(row.date).format("DD-MM-YYYY")}</td>
                        <td>
                          <strong>{fmt(row.amount)}</strong>
                        </td>
                        <td style={{ maxWidth: 200 }}>
                          <span
                            title={row.reason}
                            style={{
                              display: "block",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {row.reason}
                          </span>
                        </td>
                        <td>
                          <Badge
                            color={
                              row.status === true
                                ? "success"
                                : row.status === false
                                ? "danger"
                                : "warning"
                            }
                            className="p-2 fs-6"
                          >
                            {row.status === true
                              ? "Approved"
                              : row.status === false
                              ? "Rejected"
                              : "Pending"}
                          </Badge>
                        </td>
                        <td>
                          {row?.status === null && checkAccess(13, "edit") && (
                            <>
                              <Button
                                color="success"
                                onClick={() => toggleApprove(row.id, true)}
                              >
                                <MdCheck />
                              </Button>
                              <Button
                                color="danger"
                                className="ms-2"
                                onClick={() => toggleApprove(row.id, false)}
                              >
                                <MdCancel />
                              </Button>
                            </>
                          )}
                        </td>
                        <td>
                          <div className="d-flex gap-1 flex-wrap">
                            {checkAccess(13, "edit") && (
                              <Button
                                color="warning"
                                onClick={() => openEdit(row)}
                                title="Edit"
                              >
                                <MdEdit />
                              </Button>
                            )}
                            {checkAccess(13, "delete") && (
                              <Button
                                color="danger"
                                onClick={() => handleDelete(row.id)}
                                title="Delete"
                              >
                                <MdDelete />
                              </Button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>

            {/* ── Pagination ── */}
            <nav className="d-flex justify-content-between align-items-center mt-3">
              <h6 className="mb-0 text-muted">
                Showing{" "}
                {filtered.length === 0 ? 0 : (safePage - 1) * pageSize + 1} to{" "}
                {Math.min(safePage * pageSize, filtered.length)} of{" "}
                {filtered.length} entries
              </h6>
              <ul className="pagination mb-0">
                <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => setPage(p => Math.max(p - 1, 1))}
                  >
                    Previous
                  </button>
                </li>
                {[...Array(totalPages)].map((_, i) => (
                  <li
                    key={i + 1}
                    className={`page-item ${i + 1 === page ? "active" : ""}`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setPage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  </li>
                ))}
                <li
                  className={`page-item ${
                    page === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => setPage(p => Math.min(p + 1, totalPages))}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </CardBody>
        </Card>

        {/* ── Add / Edit Modal ── */}
        <Modal isOpen={modal} toggle={() => setModal(false)} centered size="md">
          <ModalHeader toggle={() => setModal(false)}>
            {editId ? "Edit Advance" : "Add Advance"}
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>
                Employee <span className="text-danger">*</span>
              </Label>
              <Input
                type="select"
                className="rounded-4"
                value={form.userId}
                onChange={e => setForm(f => ({ ...f, userId: e.target.value }))}
                invalid={!!formErr.userId}
              >
                <option value="">-- Select Employee --</option>
                {EMPLOYEES.map(e => (
                  <option key={e.id} value={e.id}>
                    {e.name}
                  </option>
                ))}
              </Input>
              {formErr.userId && (
                <div className="invalid-feedback d-block">{formErr.userId}</div>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Advance Date <span className="text-danger">*</span>
              </Label>
              <Input
                type="date"
                className="rounded-4"
                value={form.date}
                onChange={e => setForm(f => ({ ...f, date: e.target.value }))}
                invalid={!!formErr.date}
              />
              {formErr.date && (
                <div className="invalid-feedback d-block">{formErr.date}</div>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Amount (₹) <span className="text-danger">*</span>
              </Label>
              <Input
                type="text"
                className="rounded-4"
                placeholder="Enter amount"
                value={form.amount}
                onChange={e => {
                  allowOnlyNumbers(e)
                  setForm(f => ({ ...f, amount: e.target.value }))
                }}
                invalid={!!formErr.amount}
              />
              {formErr.amount && (
                <div className="invalid-feedback d-block">{formErr.amount}</div>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Reason <span className="text-danger">*</span>
              </Label>
              <Input
                type="textarea"
                rows={3}
                className="rounded-4"
                placeholder="Enter reason for advance"
                value={form.reason}
                onChange={e => setForm(f => ({ ...f, reason: e.target.value }))}
                invalid={!!formErr.reason}
              />
              {formErr.reason && (
                <div className="invalid-feedback d-block">{formErr.reason}</div>
              )}
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" outline onClick={() => setModal(false)}>
              Cancel
            </Button>
            <Button color="primary" onClick={handleSave}>
              {editId ? "Update" : "Save"}
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </PermittedComponent>
  )
}

export default Advance
